import React from "react";
import { ensure, Text } from "sprint-common-web";

export const renderRuntime = <T extends { runtime?: string | number }>(item?: T): JSX.Element => {
    ensure(item);

    return <Text variant="smallPlus">{item.runtime || "-"}</Text>;
};
